<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <!-- Subscription overlay -->
    <b-overlay
      :show="show"
      variant="transparent"
      :opacity="1"
      blur="3px"
    >
      <template v-slot:overlay>
        <div class="text-center">
          <p id="cancel-label">
            Please upgrade your subscription to activate this feature
          </p>
          <b-button
            ref="cancel"
            variant="primary"
            aria-describedby="cancel-label"
            @click="upgradeSubscription()"
          >
            Click here to upgrade
          </b-button>
        </div>
      </template>

      <b-row>
        <b-col md="9">
          <h4 class="font-weight-bold ml-1">Fartøy</h4>
        </b-col>

        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col>

        <b-col md="2">
          <b-button
            class="float-right"
            variant="primary"
            v-b-modal.newVessel
            @click="newVesselModal()"
          >Nytt fartøy</b-button>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="vessels"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        empty-text="There are no vessels to show"
        @filtered="onFiltered"
      >
        <template v-slot:table-caption>Totalt: {{ vessels.length | numeralFormat }} fartøy
        </template>

        <template #cell(show_on_infoscreen)="data">
          <b-badge
            pill
            :variant="data.value === false ? 'secondary' : 'success'"
          >{{ data.value === false ? "Skjult" : "Vises" }}</b-badge>
        </template>

        <template #cell(actions)="row">

          <b-button
            variant="primary"
            class="mr-1 float-center"
            size="sm"
            @click="editVessel(row.item)"
          >
            Rediger</b-button>
        </template>

      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <!-- New vessel modal -->

      <b-modal
        id="newVessel"
        title="Nytt fartøy"
      >
        <vue-typeahead-bootstrap
          class="mb-4"
          v-model="query"
          :ieCloseFix="false"
          :data="aisvessels"
          :serializer="(item) => item.name"
          @hit="vessel = $event"
          placeholder="Søk fartøy.."
          @input="lookupUser"
        />

        <b-form-group label="Navn">
          <b-form-input
            v-model="vessel.name"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="IMO nummer">
          <b-form-input
            v-model="vessel.imo"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="MMSI nummer">
          <b-form-input v-model="vessel.mmsi"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Kallesignal"
          label-for="name-input"
          invalid-feedback="Kallesignal nummer er påkrevd"
        >
          <b-form-input
            id="name-input"
            v-model="vessel.callsign"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Type">
          <b-form-select
            v-model="vessel.type"
            :options="vesselOptions"
          ></b-form-select>
        </b-form-group>

        <b-form v-if="vessel.type == 'Avlusningsfartøy'">
          <label>Antall linjer</label>
          <b-form-select
            class="mr-3"
            v-model="vessel.fls.lines"
            :options="flsLinesOptions"
          ></b-form-select>
        </b-form>

        <b-form-checkbox
          v-model="vessel.show_on_infoscreen"
          class="mt-3"
        >Vis fartøy på infoskjerm</b-form-checkbox>

        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="newVessel()"
            >
              Opprett fartøy
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeNewModal()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- New vessel modal -->

      <b-modal
        id="editVessel"
        title="Rediger fartøy"
      >
        <b-form-group label="Navn">
          <b-form-input
            v-model="vessel.name"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="IMO nummer">
          <b-form-input
            v-model="vessel.imo"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="MMSI nummer">
          <b-form-input v-model="vessel.mmsi"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Kallesignal"
          label-for="name-input"
          invalid-feedback="Kallesignal nummer er påkrevd"
        >
          <b-form-input
            id="name-input"
            v-model="vessel.callsign"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Type">
          <b-form-select
            v-model="vessel.type"
            :options="vesselOptions"
          ></b-form-select>
        </b-form-group>

        <b-form v-if="vessel.type == 'Avlusningsfartøy'">
          <label>Antall linjer</label>
          <b-form-select
            class="mr-3"
            v-model="vessel.fls.lines"
            :options="flsLinesOptions"
          ></b-form-select>
        </b-form>

        <b-form-checkbox
          v-model="vessel.show_on_infoscreen"
          class="mt-3"
        >Vis fartøy på infoskjerm</b-form-checkbox>

        <template #modal-footer>
          <div class="w-100">

            <b-button
              variant="outline-danger"
              class="float-left"
              @click="deleteVessel()"
            >
              Slett
            </b-button>

            <b-button
              variant="primary"
              class="float-right"
              @click="saveVessel()"
            >
              Lagre
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeEditModal()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- Info modal -->
      <b-modal
        :id="infoModal.id"
        :title="infoModal.title"
        ok-only
        @hide="resetInfoModal"
      >
        <pre>{{ infoModal.content }}</pre>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";
import { debounce } from "lodash";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";



export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
    VueTypeaheadBootstrap,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      vessel: {
        fls: {},
      },
      vessels: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        {
          key: "name",
          label: "Navn",
          sortable: true,
          class: "text-left",
        },
        { key: "mmsi", label: "MMSI", sortable: true },
        { key: "imo", label: "IMO", sortable: true },
        { key: "callsign", label: "Kallesignal", sortable: true },
        { key: "lat", label: "Lat" },
        { key: "lng", label: "Lng" },
        { key: "type", label: "Type", sortable: true },
        { key: "show_on_infoscreen", label: "Infoskjerm", sortable: true },
        { key: "actions", label: "Handlinger" },
      ],
      flsLinesOptions: [
        { value: 1, text: "1 Linje" },
        { value: 2, text: "2 Linjer" },
        { value: 3, text: "3 Linjer" },
        { value: 4, text: "4 Linjer" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "created",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      vesselOptions: [
        { value: "Avlusning", text: "Avlusning" },
        { value: "Brønnbåt", text: "Brønnbåt" },
        { value: "Service", text: "Service" },
        { value: "Vaktbåt", text: "Vaktbåt" },
      ],

      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      show: false,
      isLoading: false,
      fullPage: true,
      query: "",
      selecteduser: null,
      aisvessels: [],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumShipsTotal() {
      return this.ships.length;
    },
  },
  methods: {
    getVessels() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/vessels?_where[company]=" + company)
        .then((res) => {
          this.vessels = res.data;
          this.isLoading = false;
        });
    },
    getAIS() {
      axios.get("https://api.eines-as.no/ais?_where[mmsi]=").then((res) => {
        this.ships = res.data;
      });
    },
    newVessel() {
      this.vessel.company = localStorage.getItem("company");
      axios
        .post("https://api.eines-as.no/vessels/", this.vessel)
        .then((response) => {
          this.vessels.push(response.data);
          this.$bvModal.hide("newVessel");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    saveVessel() {
      axios
        .put(
          "https://api.eines-as.no/vessels/" + this.vessel.id,
          this.vessel
        )
        .then(() => {
          this.$bvModal.hide("editVessel");
          this.getVessels();
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    deleteVessel() {
      axios
        .delete("https://api.eines-as.no/vessels/" + this.vessel.id)
        .then(() => {
          this.getVessels();
          this.$bvModal.hide("editVessel");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    editVessel(vessel) {
      this.vessel = vessel;
      this.$bvModal.show("editVessel");
    },
    newVesselModal() {
      this.vessel = { show_on_infoscreen: true };
    },
    closeNewModal() {
      this.$bvModal.hide("newVessel");
    },
    closeEditModal() {
      this.$bvModal.hide("editVessel");
    },
    lookupUser: debounce(function () {
      // in practice this action should be debounced

      axios
        .get(`https://api.eines-as.no/ais?_q=${this.query}`)
        .then((response) => {
          this.aisvessels = response.data;
          console.log(this.aisvessels);
        });
    }, 500),
  },

  created: function () {
    this.getVessels();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>